import { handleActions } from "redux-actions";
import { setEnableCRUD } from "../actions/actions";

export default handleActions(
  {
    [setEnableCRUD]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
